import React, { useState, useCallback, useEffect } from 'react';
import CalendarComponent from './CalendarComponent.jsx';
import AvailabilityModal from './AvailabilityModal.jsx';
import Button from '@mui/material/Button';
import { addDays, format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import EditChoiceModal from './EditChoiceModal.jsx';
import { ToastContainer } from 'react-toastify';
import HolidayPopup from './HolidayPopup.jsx';
import 'react-toastify/dist/ReactToastify.css';
import ScheduleSummaryPopup from './SchedulerSummaryPopup.jsx';
import CustomToolbar from './CustomToolbar.jsx';
import { toast } from "react-toastify";

const Scheduler = (props) => {
  const {
    overrides,
    handleradiobutton,
    selectedDate,
    handleNavigate,
    selectedValue,
    timeValues,
    errors,
    handleSave,
    isSaveDisabled,
    handleChange,
    handleStepsback,
    handleSteps,
    bankdetails,
    EmailId,
    handlebankaccountdetails,
    timeSlotesAvailability,
    toggleCondition,
    events,
    setEvents,
    newEventTriggered,
    selectedCountry,
    handleDeleteSave,
    UpdatepslNames,
    ...rest
  } = props;

  const [calendarEvents, setCalendarEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [, setValidatedEvents] = useState([]);
  const [editMode, setEditMode] = useState('single');
  const [showHolidayPopup, setShowHolidayPopup] = useState(false);
  const [showEditChoiceModal, setShowEditChoiceModal] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const todayYear = new Date().getFullYear();
  const [selectedGroupFilter, setSelectedGroupFilter] = useState('');
  const [selectedPSLCheckboxes, setSelectedPSLCheckboxes] = useState([]);
  const [currentYear, setCurrentYear] = useState(
    selectedDate ? selectedDate.getFullYear() : todayYear
  );

  useEffect(() => {
    console.log("events", events)
  }, [events])

  useEffect(() => {

    if (!props?.areasMarked || props.areasMarked.length === 0) {
      return;
    }

    if (UpdatepslNames && UpdatepslNames.length > 0) {
      setSelectedPSLCheckboxes(UpdatepslNames);
      return;
    }

    if (UpdatepslNames && UpdatepslNames.length === 0 && selectedPSLCheckboxes.length > 0) {
      return;
    }

    const pslsWithSchedules = [];
    let firstGroupWithSchedule = null;

    props.areasMarked.forEach((area, index) => {
      const hasSchedule = area.ScheduleAvailability &&
        Array.isArray(area.ScheduleAvailability) &&
        area.ScheduleAvailability.length > 0;

      if (hasSchedule) {
        const pslName = area.pslName || area.name || `PSL ${area.id}`;
        pslsWithSchedules.push(pslName);

        if (!firstGroupWithSchedule && area.groupName) {
          firstGroupWithSchedule = area.groupName;
        }
      }
    });

    if (pslsWithSchedules.length > 0) {
      if (firstGroupWithSchedule) {
        setSelectedGroupFilter(firstGroupWithSchedule);
      }
      setSelectedPSLCheckboxes(pslsWithSchedules);
    } else {
    }
  }, [props.areasMarked]);

  useEffect(() => {
    if (!UpdatepslNames) return;

    if (UpdatepslNames.length > 0) {
      setSelectedPSLCheckboxes(UpdatepslNames);
    }
  }, [UpdatepslNames]);

  useEffect(() => {
    if (props.groups && props.groups.length > 0 && !selectedGroupFilter) {
      const firstGroup = props.groups[0];
      const groupName = firstGroup.name || firstGroup.groupName || firstGroup || 'Default';
      setSelectedGroupFilter(groupName);
    }
  }, [props.groups, selectedGroupFilter]);

  useEffect(() => {
    setCurrentYear(selectedDate ? selectedDate.getFullYear() : todayYear);
  }, [selectedDate]);

  useEffect(() => {
    let filteredEvents = events;

    if (selectedGroupFilter && selectedGroupFilter !== 'All Groups') {
      filteredEvents = filteredEvents.filter(
        evt => evt.groupName === selectedGroupFilter
      );
    }

    const convertedEvents = filteredEvents.map(evt => ({
      ...evt,
      start: new Date(evt.start),
      end: new Date(evt.end),
    }));

    setCalendarEvents(convertedEvents);
  }, [events, selectedGroupFilter, selectedPSLCheckboxes]);

  const handleEventsValidated = useCallback((validatedEvents) => {
    setValidatedEvents(validatedEvents);
  }, []);

  const handleAddEvent = (start) => {
    const selectedPSLDetails =
      props.areasMarked
        ?.filter((area) => selectedPSLCheckboxes.includes(area.pslName))
        .map((area, index) => {
          const name =
            area.name ||
            area.pslName ||
            area.displayName ||
            area.optionText ||
            `PSL ${index + 1}`;
          return { id: area.id, name };
        }) || null;

    setSelectedEvent({
      id: uuidv4(),
      title: "",
      start,
      end: new Date(start.getTime() + 60 * 60 * 1000),
      allDay: false,
      recurrence: null,
      recurrenceId: uuidv4(),
      selectedDays: [],
      endType: "Never",
      endDateOn: null,
      groupName: selectedGroupFilter || null,
      assignedPSLs: selectedPSLDetails || null,
    });

    setIsEditing(false);
    setShowModal(true);
  };

  const handleNextButtonClick = () => {
    timeSlotesAvailability();
    toggleCondition('4 of 5 - Enter Bank Details');
    toggleCondition('3 of 5 - Schedule Availability');
  };

  const groupsWithPSL = React.useMemo(() => {
    if (!props.groups || !props.areasMarked) return [];

    return props.groups.filter(group =>
      props.areasMarked.some(area =>
        area.Name === "PSL - Parking Space Location" &&
        area.groupName === group.name
      )
    );
  }, [props.groups, props.areasMarked]);

  useEffect(() => {
    if (!groupsWithPSL.length) return;

    const exists = groupsWithPSL.some(
      g => g.name === selectedGroupFilter
    );

    if (!exists) {
      setSelectedGroupFilter(groupsWithPSL[0].name);
    }
  }, [groupsWithPSL, selectedGroupFilter]);

  const eventsOverlap = (e1, e2) => {
    // 1️⃣ Group check (mandatory)
    if ((e1.groupName || "Default") !== (e2.groupName || "Default")) {
      return false;
    }

    // 2️⃣ PSL check
    const psl1 = Array.isArray(e1.assignedPSLs) ? e1.assignedPSLs : [];
    const psl2 = Array.isArray(e2.assignedPSLs) ? e2.assignedPSLs : [];

    // 👉 If BOTH empty → group-level schedule → MUST check overlap
    if (psl1.length > 0 && psl2.length > 0) {
      const pslNames1 = psl1.map(p =>
        typeof p === "object" ? (p.name || p.pslName) : p
      );
      const pslNames2 = psl2.map(p =>
        typeof p === "object" ? (p.name || p.pslName) : p
      );

      const hasCommonPSL = pslNames1.some(p => pslNames2.includes(p));
      if (!hasCommonPSL) {
        return false;
      }
    }

    // 3️⃣ Time overlap (THIS catches middle overlap)
    const start1 = new Date(e1.start);
    const end1 = new Date(e1.end);
    const start2 = new Date(e2.start);
    const end2 = new Date(e2.end);

    return start1 < end2 && end1 > start2;
  };

  const handleBackButtonClick = () => {
    props.handleConfirm(false);
    toggleCondition('2 of 5 - Mark Parking Spaces & Other Areas');
    toggleCondition('3 of 5 - Schedule Availability');
  };

  const handleSelectEvent = (event) => {
    console.log('Clicked event:', event);
    if (event.recurrenceId) {
      setSelectedEvent(event);
      setShowEditChoiceModal(true);
    } else {
      setEditMode('single');
      setSelectedEvent(event);
      setIsEditing(true);
      setShowModal(true);
    }
  };

  const handleEditChoice = (mode) => {
    setEditMode(mode);
    setIsEditing(true);
    setShowModal(true);
    setShowEditChoiceModal(false);
  };

  const handleSaveEvent = (newEvent, recurrenceChanged = false) => {
    console.log('Scheduler - Event received from AvailabilityModal:', newEvent);

    const savedEvent = { ...newEvent };

    savedEvent.groupName = selectedGroupFilter || "Default";
    savedEvent.assignedPSLs = selectedPSLCheckboxes || [];
    savedEvent.isMaster = true;
    // savedEvent.id = savedEvent.id || uuidv4();
    if (isEditing && editMode === "series") {
      savedEvent.id = selectedEvent.id; // keep same master
    } else {
      savedEvent.id = savedEvent.id || uuidv4();
    }


    /* -------------------------------------------------
       BASIC VALIDATIONS
    ------------------------------------------------- */
    const now = new Date();
    if (new Date(savedEvent.start) < now) {
      alert("Cannot save events in the past.");
      return;
    }

    if (
      savedEvent.endType === "on" &&
      savedEvent.endDateOn &&
      new Date(savedEvent.endDateOn) < new Date(savedEvent.start)
    ) {
      alert("End date cannot be earlier than start date.");
      return;
    }

    let existingEvents = [...events];

    /* -------------------------------------------------
       RECURRENCE
    ------------------------------------------------- */
    let childEvents = [];
    let masterEvent = { ...savedEvent };

    if (savedEvent.recurrence) {
      masterEvent.recurrenceId = masterEvent.recurrenceId || uuidv4();

      if (isEditing) {
        if (editMode === "series") {

          const wasExpandedCustom =
            selectedEvent.recurrence === "custom" &&
            ["day", "month", "year"].includes(
              selectedEvent.customRecurrenceType?.toLowerCase()
            );

          if (wasExpandedCustom) {
            // 🔥 CLEAN OLD EXPANDED EVENTS OF THIS SERIES
            const seriesStart = new Date(selectedEvent.start);
            const seriesEnd = selectedEvent.lastOccurrence
              ? new Date(selectedEvent.lastOccurrence)
              : new Date(seriesStart.getTime() + 365 * 24 * 60 * 60 * 1000);

            existingEvents = existingEvents.filter(e => {
              const eStart = new Date(e.start);
              return !(
                e.groupName === selectedEvent.groupName &&
                e.title === selectedEvent.title &&
                eStart >= seriesStart &&
                eStart <= seriesEnd
              );
            });
          } else {
            // 🔥 NORMAL SERIES CLEANUP (weekly, monthly, etc.)
            existingEvents = existingEvents.filter(
              e => e.recurrenceId !== selectedEvent.recurrenceId
            );
          }

          // ✅ Always keep recurrenceId stable for new series
          masterEvent.recurrenceId =
            selectedEvent.recurrenceId || uuidv4();

        } else {
          // ✅ single occurrence edit
          existingEvents = existingEvents.filter(
            e => e.id !== selectedEvent.id
          );
          masterEvent.recurrenceId = null;
        }
      }

      switch (savedEvent.recurrence) {
        case "custom":
          childEvents = generateCustomRecurringEvents(
            masterEvent,
            new Date(masterEvent.start),
            new Date(masterEvent.end) - new Date(masterEvent.start),
            masterEvent.endAfter,
            masterEvent.endDateOn ? new Date(masterEvent.endDateOn) : null
          );
          break;

        case "daily":
        case "weekly":
        case "bi-weekly":
        case "monthly":
        case "yearly":
          childEvents = generateRecurringEvents(masterEvent);
          break;

        case "weekdays":
          childEvents = generateWeekdayRecurringEvents(
            masterEvent,
            new Date(masterEvent.start),
            new Date(masterEvent.end) - new Date(masterEvent.start),
            masterEvent.endAfter,
            masterEvent.endDateOn ? new Date(masterEvent.endDateOn) : null
          );
          break;

        case "weekends":
          masterEvent.selectedDays = ["Sat", "Sun"];
          masterEvent.customRecurrenceType = "week";
          masterEvent.customRecurrenceCount = 1;

          childEvents = generateWeekendRecurringEvents(
            masterEvent,
            new Date(masterEvent.start),
            new Date(masterEvent.end) - new Date(masterEvent.start),
            masterEvent.endAfter,
            masterEvent.endDateOn ? new Date(masterEvent.endDateOn) : null
          );
          break;

        default:
          break;
      }
      const isExpandedCustom =
        savedEvent.recurrence === 'custom' &&
        ['day', 'month', 'year'].includes(
          savedEvent.customRecurrenceType?.toLowerCase()
        );


      if (isExpandedCustom) {
        childEvents = childEvents.map(evt => ({
          ...evt,
          recurrence: null,
          recurrenceId: null,
          occurrences: null,
          customRecurrenceType: null,
          customRecurrenceCount: null,
          selectedDays: [],
          endType: null,
          endAfter: null,
          endDateOn: null,
          isMaster: false
        }));
      }
      else {
        childEvents = childEvents.map(e => ({
          ...e,
          isMaster: false,
          groupName: masterEvent.groupName,
          assignedPSLs: masterEvent.assignedPSLs,
        }));
      }
    }

    /* -------------------------------------------------
       EXCLUDE EVENT BEING EDITED FROM OVERLAP CHECK
    ------------------------------------------------- */
    if (isEditing && selectedEvent) {
      if (editMode === "series" && selectedEvent.recurrenceId) {
        existingEvents = existingEvents.filter(
          e => e.recurrenceId !== selectedEvent.recurrenceId
        );
      } else if (selectedEvent.id) {
        existingEvents = existingEvents.filter(
          e => e.id !== selectedEvent.id
        );
      }
    }

    /* -------------------------------------------------
       OVERLAP VALIDATION (MASTER + CHILDREN)
    ------------------------------------------------- */
    const eventsToCheck = savedEvent.recurrence
      ? [masterEvent, ...childEvents]
      : [masterEvent];

    const hasOverlap = eventsToCheck.some(evtA =>
      existingEvents.some(evtB => eventsOverlap(evtA, evtB))
    );

    if (hasOverlap) {
      alert("Cannot save events that overlap with existing events.");
      return;
    }

    /* -------------------------------------------------
       SAVE TO STATE (MASTER IS REQUIRED)
    ------------------------------------------------- */
    const isCustomWeek =
      savedEvent.recurrence === "custom" &&
      savedEvent.customRecurrenceType?.toLowerCase() === "week";
    setEvents([
      ...existingEvents,
      ...(isCustomWeek ? childEvents : [masterEvent, ...childEvents]),
    ]);
    setEvents([
      ...existingEvents,
      masterEvent,
      ...childEvents,
    ]);

    /* -------------------------------------------------
       SAVE TO AREAS (PSL)
    ------------------------------------------------- */
    if (props.areasMarked && masterEvent.assignedPSLs.length > 0) {
      const assignedNames = masterEvent.assignedPSLs.map(p =>
        (typeof p === "string" ? p : p.name || p.pslName)
          .toLowerCase()
          .trim()
      );

      const updatedAreas = props.areasMarked.map(area => {
        const areaName = (area.pslName || area.name || "")
          .toLowerCase()
          .trim();

        if (!assignedNames.includes(areaName)) return area;

        const schedule = Array.isArray(area.ScheduleAvailability)
          ? [...area.ScheduleAvailability]
          : [];

        if (isEditing && editMode === "series") {
          schedule.splice(
            0,
            schedule.length,
            ...schedule.filter(s => s.recurrenceId !== masterEvent.recurrenceId)
          );
        }

        schedule.push({
          ...masterEvent,
          start: masterEvent.start,
          end: masterEvent.end,
        });

        return { ...area, ScheduleAvailability: schedule };
      });

      props.setAreasMarked?.(updatedAreas);
    }

    newEventTriggered(masterEvent);
    handleCloseModal();
  };

  const handleDeleteEvent = (event) => {
    if (!event) return;
    const isExpandedCustom =
      event.recurrence === "custom" &&
      ["day", "month", "year"].includes(
        event.customRecurrenceType?.toLowerCase()
      );
    setEvents((prevEvents) => {
      if (editMode === "series") {
        if (isExpandedCustom) {
          const seriesStart = new Date(event.start);
          const seriesEnd = event.endAfter
            ? new Date(seriesStart.getTime() + event.endAfter * 24 * 60 * 60 * 1000)
            : event.endDateOn
              ? new Date(event.endDateOn)
              : new Date(seriesStart.getTime() + 365 * 24 * 60 * 60 * 1000);

          return prevEvents.filter((e) => {
            const eStart = new Date(e.start);
            return !(
              e.groupName === event.groupName &&
              e.title === event.title &&
              eStart >= seriesStart &&
              eStart <= seriesEnd
            );
          });
        }

        // ✅ NORMAL RECURRENCE (week / bi-week / monthly)
        return prevEvents.filter(
          (e) =>
            e.recurrenceId !== event.recurrenceId &&
            e.id !== event.id
        );
      }

      // ✅ SINGLE OCCURRENCE DELETE
      return prevEvents.filter((e) => e.id !== event.id);
    });

    toast.success(
      editMode === "series"
        ? "Series deleted successfully."
        : "Occurrence deleted successfully."
    );

    handleCloseModal();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setSelectedEvent(null);
    setEditMode('single');
  };

  const getFirstWeeklyOccurrence = (startDate, selectedDays) => {
    const dayMap = {
      Sun: 0, Mon: 1, Tue: 2, Wed: 3,
      Thu: 4, Fri: 5, Sat: 6,
    };
    const selectedIndexes = selectedDays.map(d => dayMap[d]);
    let date = new Date(startDate);
    // ⛔ If startDate day DOES NOT match, move forward
    while (!selectedIndexes.includes(date.getDay())) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  };

  function generateCustomRecurringEvents(event, startDate, duration, occurrences, endDateOn) {
    console.log("DEBUG: generateCustomRecurringEvents", {
      selectedDays: event.selectedDays,
      type: event.customRecurrenceType,
      count: event.customRecurrenceCount,
      startDate,
      duration,
      occurrences,
      endDateOn
    });

    let lastOccurrenceDate = null;

    let selectedDays = Array.isArray(event.selectedDays) && event.selectedDays.length > 0
      ? event.selectedDays
      : [format(startDate, "EEE")];
    selectedDays = selectedDays.map(d => d.slice(0, 3));

    const interval = parseInt(event.customRecurrenceCount, 10) || 1;
    const maxOccurrences = occurrences || 52;
    const type = event.customRecurrenceType || "week";

    let totalCreated = 0;
    let masterEventCreated = false;
    let events = [];

    if (type === "day") {
      let currentDate = new Date(startDate);

      while (totalCreated < maxOccurrences && (!endDateOn || currentDate <= endDateOn)) {
        if (currentDate >= startDate && (!endDateOn || currentDate <= endDateOn)) {
          const baseEvent = {
            ...event,
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes()
              )
            ),
            end: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes() + duration / 60000
              )
            ),
          };

          if (!masterEventCreated) {
            events.push({
              ...baseEvent,
              id: event.id || uuidv4(),
              isMaster: true,
              lastOccurrence: null,
            });
            masterEventCreated = true;
          } else {
            events.push({
              ...baseEvent,
              id: uuidv4(),
              isMaster: false,
            });
          }
          totalCreated++;
          lastOccurrenceDate = new Date(currentDate);
        }

        currentDate.setDate(currentDate.getDate() + interval);
      }
    }
    else if (type === "week") {
      // Align to the first valid selected weekday
      let weekCursor = getFirstWeeklyOccurrence(startDate, selectedDays);
      const dayOrder = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      while (
        totalCreated < maxOccurrences &&
        (!endDateOn || weekCursor <= new Date(endDateOn))
      ) {
        // 🔹 For EACH selected weekday in the same week
        for (const day of selectedDays) {
          if (totalCreated >= maxOccurrences) break;
          const current = new Date(weekCursor);
          const targetDayIndex = dayOrder.indexOf(day);
          const currentDayIndex = current.getDay();
          // Move to the selected weekday in the SAME week
          current.setDate(
            current.getDate() + ((targetDayIndex - currentDayIndex + 7) % 7)
          );
          // ⛔ Skip invalid dates
          if (
            current < startDate ||
            (endDateOn && current > new Date(endDateOn))
          ) {
            continue;
          }
          // ✅ KEEP YOUR EXISTING EVENT CREATION LOGIC
          const baseEvent = {
            ...event,
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(
              new Date(
                current.getFullYear(),
                current.getMonth(),
                current.getDate(),
                startDate.getHours(),
                startDate.getMinutes()
              )
            ),
            end: formatLocalDateTime(
              new Date(
                current.getFullYear(),
                current.getMonth(),
                current.getDate(),
                startDate.getHours(),
                startDate.getMinutes() + duration / 60000
              )
            ),
          };

          if (!masterEventCreated) {
            events.push({
              ...baseEvent,
              id: event.id || uuidv4(),
              isMaster: true,
              lastOccurrence: null,
            });
            masterEventCreated = true;
          } else {
            events.push({
              ...baseEvent,
              id: uuidv4(),
              isMaster: false,
            });
          }
          totalCreated++;
          lastOccurrenceDate = new Date(current);
        }
        weekCursor.setDate(weekCursor.getDate() + 7 * interval);
      }
    }
    else if (type === "month") {
      let currentDate = new Date(startDate);

      while (totalCreated < maxOccurrences && (!endDateOn || currentDate <= endDateOn)) {
        if (currentDate >= startDate && (!endDateOn || currentDate <= endDateOn)) {
          const baseEvent = {
            ...event,
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes()
              )
            ),
            end: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes() + duration / 60000
              )
            ),
          };

          if (!masterEventCreated) {
            events.push({
              ...baseEvent,
              id: event.id || uuidv4(),
              isMaster: true,
              lastOccurrence: null
            });
            masterEventCreated = true;
          } else {
            events.push({
              ...baseEvent,
              id: uuidv4(),
              isMaster: false
            });
          }

          totalCreated++;
          lastOccurrenceDate = new Date(currentDate);
        }

        const nextMonth = new Date(currentDate);
        nextMonth.setMonth(nextMonth.getMonth() + interval);

        if (nextMonth.getDate() !== currentDate.getDate()) {
          nextMonth.setDate(0);
        }

        currentDate = nextMonth;
      }
    }
    else if (type === "year") {
      let currentDate = new Date(startDate);

      while (totalCreated < maxOccurrences && (!endDateOn || currentDate <= endDateOn)) {
        if (currentDate >= startDate && (!endDateOn || currentDate <= endDateOn)) {
          const baseEvent = {
            ...event,
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes()
              )
            ),
            end: formatLocalDateTime(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startDate.getHours(),
                startDate.getMinutes() + duration / 60000
              )
            ),
          };

          if (!masterEventCreated) {
            events.push({
              ...baseEvent,
              id: event.id || uuidv4(),
              isMaster: true,
              lastOccurrence: null,
            });
            masterEventCreated = true;
          } else {
            events.push({
              ...baseEvent,
              id: uuidv4(),
              isMaster: false,
            });
          }
          totalCreated++;
          lastOccurrenceDate = new Date(currentDate);
        }

        const nextYear = new Date(currentDate);
        nextYear.setFullYear(nextYear.getFullYear() + interval);

        if (nextYear.getMonth() !== currentDate.getMonth()) {
          nextYear.setDate(0);
        }

        currentDate = nextYear;
      }
    } else {
      return [];
    }

    if (events.length > 0 && events[0].isMaster) {
      events[0].lastOccurrence = lastOccurrenceDate
        ? formatLocalDateTime(lastOccurrenceDate)
        : null;
    }
    return events;
  }

  function formatLocalDateTime(date) {
    if (!(date instanceof Date)) date = new Date(date);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${y}-${m}-${d}T${hh}:${mm}`;
  }

  function generateWeekdayRecurringEvents(
    event,
    startDate,
    duration,
    occurrences,
    endDateOn
  ) {
    if (!(startDate instanceof Date)) {
      startDate = new Date(startDate);
    }
    if (endDateOn && !(endDateOn instanceof Date)) {
      endDateOn = new Date(endDateOn);
    }

    const childEvents = [];
    let currentDate = new Date(startDate);
    let generatedCount = 0;
    let lastOccurrenceDate = null;

    const maxOccurrences = occurrences || 365;

    while (
      generatedCount < maxOccurrences &&
      (!endDateOn || currentDate <= endDateOn)
    ) {
      const dayOfWeek = currentDate.getDay();

      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        if (generatedCount === 0) {
          lastOccurrenceDate = new Date(currentDate);
          generatedCount++;
        } else {
          const childEvent = {
            ...event,
            id: uuidv4(),
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(currentDate),
            end: formatLocalDateTime(
              new Date(currentDate.getTime() + duration)
            ),
            isMaster: false,
          };
          childEvents.push(childEvent);
          lastOccurrenceDate = new Date(currentDate);
          generatedCount++;
        }
      }

      currentDate = addDays(currentDate, 1);
    }

    const masterEvent = {
      ...event,
      id: event.id || uuidv4(),
      recurrenceId: event.recurrenceId,
      isMaster: true,
      start: formatLocalDateTime(startDate),
      end: formatLocalDateTime(new Date(startDate.getTime() + duration)),
      lastOccurrence: lastOccurrenceDate
        ? formatLocalDateTime(lastOccurrenceDate)
        : null,
    };
    return [masterEvent, ...childEvents];
  }

  function generateWeekendRecurringEvents(
    event,
    startDate,
    duration,
    occurrences,
    endDateOn,
    interval = 1
  ) {
    if (!(startDate instanceof Date)) {
      startDate = new Date(startDate);
    }
    if (endDateOn && !(endDateOn instanceof Date)) {
      endDateOn = new Date(endDateOn);
    }

    const childEvents = [];
    let generatedOccurrences = 0;
    let lastOccurrenceDate = null;

    if (startDate.getDay() === 0) {
      lastOccurrenceDate = new Date(startDate);
      generatedOccurrences++;
      startDate.setDate(startDate.getDate() + 1);
    }

    let currentDate = new Date(startDate);

    while (
      (!occurrences || generatedOccurrences < occurrences) &&
      (!endDateOn || currentDate <= endDateOn)
    ) {
      const saturday = nextSaturday(currentDate);
      if (
        saturday >= startDate &&
        (!endDateOn || saturday <= endDateOn) &&
        (!occurrences || generatedOccurrences < occurrences)
      ) {
        if (generatedOccurrences === 0) {
          lastOccurrenceDate = new Date(saturday);
          generatedOccurrences++;
        } else {
          const childSat = {
            ...event,
            id: uuidv4(),
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(saturday),
            end: formatLocalDateTime(
              new Date(saturday.getTime() + duration)
            ),
            isMaster: false
          };
          childEvents.push(childSat);
          lastOccurrenceDate = new Date(saturday);
          generatedOccurrences++;
        }
      }

      const sunday = nextSunday(currentDate);
      if (
        sunday >= startDate &&
        (!endDateOn || sunday <= endDateOn) &&
        (!occurrences || generatedOccurrences < occurrences)
      ) {
        if (generatedOccurrences === 0) {
          lastOccurrenceDate = new Date(sunday);
          generatedOccurrences++;
        } else {
          const childSun = {
            ...event,
            id: uuidv4(),
            recurrenceId: event.recurrenceId,
            start: formatLocalDateTime(sunday),
            end: formatLocalDateTime(
              new Date(sunday.getTime() + duration)
            ),
            isMaster: false
          };
          childEvents.push(childSun);
          lastOccurrenceDate = new Date(sunday);
          generatedOccurrences++;
        }
      }

      currentDate = addWeeks(currentDate, interval);
    }

    const masterStart = event.start;
    const startDT = new Date(masterStart);

    const masterEvent = {
      ...event,
      id: event.id || uuidv4(),
      isMaster: true,
      recurrenceId: event.recurrenceId,
      start: formatLocalDateTime(startDT),
      end: formatLocalDateTime(new Date(startDT.getTime() + duration)),
      lastOccurrence: lastOccurrenceDate
        ? formatLocalDateTime(lastOccurrenceDate)
        : null
    };

    return [masterEvent, ...childEvents];
  }

  function nextSaturday(date) {
    const temp = new Date(date);
    const day = temp.getDay();
    const offset = (6 - day + 7) % 7;
    temp.setDate(temp.getDate() + offset);
    return temp;
  }

  function nextSunday(date) {
    const temp = new Date(date);
    const day = temp.getDay();
    const offset = (7 - day + 7) % 7;
    temp.setDate(temp.getDate() + offset);
    return temp;
  }

  function addWeeks(date, n) {
    const copy = new Date(date);
    copy.setDate(copy.getDate() + n * 7);
    return copy;
  }

  function handleSummaryEdit(event) {
    setSelectedEvent(event);
    setIsEditing(true);

    if (event.recurrenceId) {
      setEditMode('series');
    } else {
      setEditMode('single');
    }

    setShowModal(true);
  }

  function generateRecurringEvents(event) {
    const finalEvents = [];
    const startDateTime = new Date(event.start);
    const endDateTime = new Date(event.end);
    const duration = endDateTime - startDateTime;

    const recurrenceId = event.recurrenceId || uuidv4();
    let endConditionDate = null;
    let maxOccurrences = Infinity;
    let lastOccurrenceDate = null;

    if (event.endType === 'on' && event.endDateOn) {
      endConditionDate = new Date(event.endDateOn);
    } else if (event.endType === 'after' && event.endAfter) {
      maxOccurrences = parseInt(event.endAfter, 10) || 1;
    } else {
      maxOccurrences = 365;
    }

    let generatedOccurrences = 0;
    let currentDate = new Date(startDateTime);

    while (
      generatedOccurrences < maxOccurrences &&
      (!endConditionDate || currentDate <= endConditionDate)
    ) {
      if (generatedOccurrences === 0) {
        lastOccurrenceDate = new Date(currentDate);
        generatedOccurrences++;
      } else {
        const child = {
          ...event,
          id: uuidv4(),
          recurrenceId,
          start: formatLocalDateTime(currentDate),
          end: formatLocalDateTime(new Date(currentDate.getTime() + duration)),
          isMaster: false,
        };
        finalEvents.push(child);
        lastOccurrenceDate = new Date(currentDate);
        generatedOccurrences++;
      }
      currentDate = getNextOccurrence(currentDate, event);
    }

    const masterEvent = {
      ...event,
      id: event.id || uuidv4(),
      recurrenceId,
      isMaster: true,
      start: formatLocalDateTime(startDateTime),
      end: formatLocalDateTime(new Date(startDateTime.getTime() + duration)),
      lastOccurrence: lastOccurrenceDate
        ? formatLocalDateTime(lastOccurrenceDate)
        : null,
    };

    return [masterEvent, ...finalEvents];
  }

  function getNextOccurrence(currentDate, event) {
    let next = new Date(currentDate);
    const originalStart = new Date(event.start);
    switch (event.recurrence) {
      case 'daily':
        next.setDate(next.getDate() + 1);
        break;
      case 'weekly':
        next.setDate(next.getDate() + 7);
        break;
      case 'bi-weekly':
        next.setDate(next.getDate() + 14);
        break;
      case 'monthly':
        next.setMonth(next.getMonth() + 1);
        break;
      case 'yearly':
        next.setFullYear(next.getFullYear() + 1);
        break;
      default:
        next.setDate(next.getDate() + 1);
        break;
    }
    next.setHours(originalStart.getHours(), originalStart.getMinutes(), 0, 0);
    return next;
  }

  function handleSummaryDelete(event) {
    const isSure = window.confirm('Are you sure you want to delete this event?');
    if (!isSure) return;

    if (event.recurrenceId) {
      setEvents((prevEvents) =>
        prevEvents.filter((e) => e.recurrenceId !== event.recurrenceId)
      );

      if (props.areasMarked && props.setAreasMarked) {
        const updatedAreas = props.areasMarked.map((area) => {
          if (!area.ScheduleAvailability || !Array.isArray(area.ScheduleAvailability)) {
            return area;
          }

          const beforeCount = area.ScheduleAvailability.length;
          const updatedSchedule = area.ScheduleAvailability.filter(
            (schedule) => schedule.recurrenceId !== event.recurrenceId
          );
          const afterCount = updatedSchedule.length;

          if (beforeCount !== afterCount) {
          }
          return {
            ...area,
            ScheduleAvailability: updatedSchedule,
          };
        });
        props.setAreasMarked(updatedAreas);
      }

    } else {
      setEvents((prevEvents) =>
        prevEvents.filter((e) => e.id !== event.id)
      );

      if (props.areasMarked && props.setAreasMarked) {
        const updatedAreas = props.areasMarked.map((area) => {
          if (!area.ScheduleAvailability || !Array.isArray(area.ScheduleAvailability)) {
            return area;
          }
          const beforeCount = area.ScheduleAvailability.length;
          const updatedSchedule = area.ScheduleAvailability.filter((schedule) => {
            if (schedule.id && event.id && schedule.id === event.id) {
              return false;
            }
            if (
              schedule.start === event.start &&
              schedule.end === event.end &&
              schedule.groupName === event.groupName
            ) {
              return false;
            }

            return true;
          });
          const afterCount = updatedSchedule.length;
          if (beforeCount !== afterCount) {
          }
          return {
            ...area,
            ScheduleAvailability: updatedSchedule,
          };
        });
        props.setAreasMarked(updatedAreas);
      }
    }
  }

  const handleHolidaySelect = (holiday) => {
    const holidayDateStr = holiday.date;

    const startStr = `${holidayDateStr}T00:00:00`;
    const endStr = `${holidayDateStr}T23:59:59`;

    const holidayEventDetails = {
      id: uuidv4(),
      title: holiday.name,
      start: startStr,
      end: endStr,
      allDay: true,
      recurrence: null,
      recurrenceId: null,
    };

    setSelectedEvent(holidayEventDetails);
    setIsEditing(false);
    setShowModal(true);
  }

  const handleOpenModal = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const date = today.getDate();

    // Create Date objects for 12:00 AM and 1:00 AM
    const startTime = new Date(year, month, date, 0, 0, 0); // 12:00 AM
    const endTime = new Date(year, month, date, 1, 0, 0);   // 1:00 AM

    setSelectedEvent({
      id: uuidv4(),
      title: '',
      // start: startTime.toISOString(), // Set default Start time
      // end: endTime.toISOString(),     // Set default End time
      start: startTime,
      end: endTime,
      allDay: false,
      recurrence: null,
      recurrenceId: uuidv4(),
      selectedDays: [],
      endType: 'Never',
      endDateOn: null,
    });
    setIsEditing(false);
    setShowModal(true);
  };

  return (
    <div className="Scheduler">
      <ToastContainer />
      <button
        onClick={() => setShowSummary(true)}
        className="show-summary-btn"
      >
        Show Summary
      </button>

      {showSummary && (
        <ScheduleSummaryPopup
          open={showSummary}
          events={events}
          onClose={() => setShowSummary(false)}
          onEdit={handleSummaryEdit}
          onDelete={handleSummaryDelete}
        />
      )}

      <HolidayPopup
        open={showHolidayPopup}
        onClose={() => setShowHolidayPopup(false)}
        onHolidaySelect={handleHolidaySelect}
        selectedCountry={selectedCountry}
        currentYear={currentYear}
      />

      <CalendarComponent
        events={calendarEvents}
        onSelectEvent={handleSelectEvent}
        onAddEvent={handleAddEvent}
        onOpenModal={() => setShowModal(true)}
        onEventsValidated={handleEventsValidated}
        selectedDate={selectedDate}
        onNavigate={handleNavigate}
        components={{
          toolbar: (toolbarProps) => (
            <CustomToolbar
              {...toolbarProps}
              onShowHolidays={() => setShowHolidayPopup(true)}
              region={selectedCountry}
              groups={props.groups}
              areasMarked={props.areasMarked}
              selectedGroupFilter={selectedGroupFilter}
              setSelectedGroupFilter={setSelectedGroupFilter}
              selectedPSLCheckboxes={selectedPSLCheckboxes}
              setSelectedPSLCheckboxes={setSelectedPSLCheckboxes}
            />
          ),
        }}
      />
      <div className="mb-3">
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal}
          style={{ marginTop: '2vh' }}
        >
          SCHEDULE HOURS ROBOTAXIS ARE NOT TO USE PARKING SPACE
        </Button>
      </div>
      <EditChoiceModal
        show={showEditChoiceModal}
        onClose={() => setShowEditChoiceModal(false)}
        onEditChoice={handleEditChoice}
      />

      <AvailabilityModal
        show={showModal}
        onClose={handleCloseModal}
        onSave={handleSaveEvent}
        onDelete={handleDeleteEvent}
        isEditing={isEditing}
        editMode={editMode}
        handleDeleteSave={handleDeleteSave}
        eventDetails={
          selectedEvent || {
            title: '',
            start: '',
            end: '',
            recurrence: '',
            allDay: false,
            recurrenceId: null,
          }
        }
      />
      <div style={{ textAlign: 'end', marginTop: '40px ', marginRight: '7vw' }}>
        <div
          className="back-wrapper"
          style={{
            width: '100px',
            backgroundColor: '#fff',
            boxShadow: '0 0 3px 2px #cec7c759',
          }}
          onClick={handleBackButtonClick}
        >
          <b className="next">Go Back</b>
        </div>
        <div
          className="next-wrapper"
          onClick={handleNextButtonClick}
          style={{
            backgroundColor: '#fff',
            boxShadow: '0 0 3px 2px #cec7c759',
          }}
        >
          <b className="next">Next</b>
        </div>
        <div
          className="autosave1-wrapper"
          onClick={(e) => handleSave(e)}
          style={{
            pointerEvents: isSaveDisabled ? 'none' : 'auto',
            opacity: isSaveDisabled ? 0.5 : 1,
            marginRight: '30px',
            backgroundColor: '#6ACD54',
            boxShadow: '0 0 3px 2px #cec7c759',
          }}
        >
          <b className="next">Save</b>
        </div>
      </div>
    </div>
  );
};

export default Scheduler;